module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAnUlEQVQoU2NUlhKSvfvs3VMGBoZ/DHgAo5K4aAUjI0PwP4Z/2fdfvD2FSy1MYTvYxP+Mc5mZWapuPXv2Bl0DskKY3FsGxv/Vd5+/mY3sHGwKYRrOIDsHn0KQBrhziFE4h5mZpRqfwtP/Gf5l33vx9jTIaGwK30A9MweXZ0DuAVuDM3iYGBkD/zH8zYFZgy3QGVWkhWTuPH33jFAUAgBE0lDpHE8yPAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/y.png
// module id = DF7q
// module chunks = 1